import { styled } from "@mui/material/styles";
const TranLayoutWrapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    paddingTop: "10px",
  },
  [theme.breakpoints.between("md", "lg")]: {
    paddingTop: "40px",
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: "10px",
  },
  [theme.breakpoints.up("lg")]: {
    paddingTop: "40px",
  },
}));
const LayoutWrap = styled("div")(({ theme }) => ({
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "90%",
  },
}));
const ContactMain = styled("div")(({ theme }) => ({
  paddingLeft: "30px",
  width: "70%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    paddingLeft: "0px",
  },
  [theme.breakpoints.only("md")]: {
    width: "90%",
    margin: "0 auto",
  },
}));

export { TranLayoutWrapper, LayoutWrap, ContactMain };
